/**
 * A member's free-text role ("Backend Developer", "QA Lead") read as one of
 * the workbench's role ids, when that is obvious. The host's
 * `inferRoleId` (src/coordination/roles.ts) is this function, and the
 * webview reads the same words when it shows a member's defaults.
 *
 * No imports: the webview reads it as well as the host.
 */
export const ROLE_IDS = [
    "ops-manager",
    "planner",
    "implementer",
    "reviewer",
    "integrator",
    "researcher",
    "scribe",
    "diagrammer",
    "debugger",
    "generalist",
];
/** Normalise a free-text role to a role id when obvious; undefined when it is not. */
export function roleIdFromWords(role) {
    if (!role)
        return undefined;
    const r = role.toLowerCase();
    if (ROLE_IDS.includes(r))
        return r;
    if (/ops|operations|manager|lead/.test(r))
        return "ops-manager";
    if (/plan|architect/.test(r))
        return "planner";
    if (/review|qa|quality|test/.test(r))
        return "reviewer";
    if (/integrat|merge|release/.test(r))
        return "integrator";
    if (/research|analy/.test(r))
        return "researcher";
    // Before the scribe: a "documentation diagrammer" or "documentation designer" draws.
    if (/diagram|design|illustrat|visual|\bu[ix]\b|mock-?up/.test(r))
        return "diagrammer";
    if (/doc|writer|scribe|technical writ/.test(r))
        return "scribe";
    // Before the implementer catch-all: "debug engineer" is a debugger first.
    if (/debug|troubleshoot|diagnos|fix|bug/.test(r))
        return "debugger";
    if (/dev|engineer|implement|coder|build/.test(r))
        return "implementer";
    if (/general|assistant|all.?round|helper/.test(r))
        return "generalist";
    return undefined;
}
//# sourceMappingURL=roleWords.js.map